import { type ApiResponse, post } from "@src/appV2/api/api";
import { APP_V2_APP_EVENTS } from "@src/appV2/lib/analytics";
import {
  useMutation,
  type UseMutationOptions,
  type UseMutationResult,
} from "@tanstack/react-query";
import { type AxiosError } from "axios";
import { z } from "zod";

const validatePhoneOtpRequestSchema = z.object({
  phone: z.string(),
  otp: z.string(),
});

const validatePhoneOtpResponseSchema = z.object({
  error: z.string().optional(),
  message: z.string().optional(),
});

export type ValidatePhoneOtpRequest = z.infer<typeof validatePhoneOtpRequestSchema>;
export type ValidatePhoneOtpResponse = z.infer<typeof validatePhoneOtpResponseSchema>;
export interface ValidatePhoneOtpErrorResponse {
  message?: string;
  error?: string;
}

export const VALIDATE_PHONE_OTP_PATH = "/agentProfile/validateOTP";

export function useValidatePhoneOtp(
  options: UseMutationOptions<
    ApiResponse<ValidatePhoneOtpResponse>,
    AxiosError<ValidatePhoneOtpErrorResponse>,
    ValidatePhoneOtpRequest
  > = {}
): UseMutationResult<
  ApiResponse<ValidatePhoneOtpResponse>,
  AxiosError<ValidatePhoneOtpErrorResponse>,
  ValidatePhoneOtpRequest
> {
  return useMutation<
    ApiResponse<ValidatePhoneOtpResponse>,
    AxiosError<ValidatePhoneOtpErrorResponse>,
    ValidatePhoneOtpRequest
  >({
    mutationFn: async ({ phone, otp }) => {
      return await post({
        url: VALIDATE_PHONE_OTP_PATH,
        data: { phone, otp },
        requestSchema: validatePhoneOtpRequestSchema,
        responseSchema: validatePhoneOtpResponseSchema,
      });
    },
    meta: {
      logErrorMessage: APP_V2_APP_EVENTS.VALIDATE_OTP_FAILURE,
    },
    ...options,
  });
}
